import {
  Container,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Logo from '../Logo/Logo';

/** Unexpected error component props */
interface UnexpectedErrorProps {
  /**
   * A message specific to the context it's showing for. This should fit: "We encountered an error while loading {errorContext}."
   */
  errorContext: string;
}

/**
 * The unexpected error component can be shown when a page does not successfully
 *  load the required data to display correctly.
 */
const UnexpectedError = (props: UnexpectedErrorProps) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Container
      maxWidth="md"
      sx={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Grid container spacing={4}>
        <Grid item xs={12} md={7}>
          <Typography
            variant="h1"
            marginBottom=".25em"
            sx={{
              textAlign: {
                xs: 'center',
                md: 'left',
              },
            }}
          >
            Oops!
          </Typography>
          <Typography
            fontSize="1.2em"
            sx={{
              textAlign: {
                xs: 'center',
                md: 'left',
              },
            }}
          >
            We encountered an error while loading {props.errorContext}. Please
            try refreshing this page. If this continues, contact us.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={5}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Logo showText={!isMd} sizeEm={isMd ? 13 : 3} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default UnexpectedError;
